<template>
    <span>
        <p v-if="playersError">
            We couldn't load your players. Please try again later.
        </p>
        <div
            v-if="0 === players.length && ! formLoading"
        >
            No Players to show.
        </div>
        <base-loader
            v-if="formLoading"
        />
    </span>
</template>

<script>
export default {
    props: {
        formLoading: {
            type: Boolean,
            required: true,
        },
        playersError: {
            type: Boolean,
            required: true,
        },
        players: {
            type: [Boolean, Array],
            default: () => [],
        },
    },
};
</script>
